import React, { useState } from 'react';

const ChatBox = () => {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');

  const handleSend = async () => {
    if (!input.trim()) return;

    // Add user message
    setMessages((prev: any) => [...prev, { text: input, isUser: true }]);
    
    try {
      // Send message to n8n chat workflow
      // const n8nUrl = 'http://165.227.86.134:5678/webhook/rexi-chat';
      const n8nUrl = 'https://askrexi.comverex.ai/webhook/rexi-chat';
      
      console.log('Sending message to n8n chat:', input);
      
      const response = await fetch(n8nUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          message: input,
          timestamp: new Date().toISOString()
        }),
      });
      
      const raw = await response.text();
      console.log('RAW FROM WEBHOOK:', raw);

      if (response.ok) {
        setMessages((prev: any) => [...prev, { text: raw, isUser: false }]);
      } else {
        setMessages((prev: any) => [...prev, { text: `Error: ${response.status}`, isUser: false }]);
      }
      
    } catch (error: any) {
      console.error('Error sending message to n8n:', error);
      setMessages((prev: any) => [...prev, { text: 'Connection error occurred', isUser: false }]);
    }
    
    setInput('');
  };

  return (
    <div className="chat-box">
      <div className="messages">
        {messages.map((message: any, index: number) => (
          <div key={index} className={`message ${message.isUser ? 'user' : 'rexi'}`}>
            {message.text}
          </div>
        ))}
      </div>
      <div className="input-area">
        <input
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="Ask Rexi a question..."
        />
        <button onClick={handleSend}>Send</button>
      </div>
    </div>
  );
};

export default ChatBox;